import React from "react"
import Subscribe from "./subscribe"
import Instagram from "./instagram"
import SweetwaterRewards from "./sweetwater-rewards"
import Footer from "./footer"
import Navbar from "./navbar"
import Alert from "./alert"
import CasinoAlert from "./casino-alert"
import Modal from "./modal"

const Layout = ({ isHomePage, children, uri, location, pageOptions }) => {
  const displayCasinoAlert = pageOptions?.displayCasinoAlert
  const hideSubscribeForm = pageOptions?.hideSubscribeForm
  const isAppView = location?.search?.includes("appview=1") ? true : false
  return (
    <div className="global-wrapper" id="top" data-is-root-path={isHomePage}>
      {!isAppView ?
        <>
          <Navbar uri={uri} />
          <Alert uri={uri} />
          <Modal />
        </> : null}
      {displayCasinoAlert ? <CasinoAlert /> : null}
      <main id="main-content">{children}</main>
      {uri === "/" ? <Instagram /> : null}
      {!isAppView ?
        <>
          {hideSubscribeForm ? null : <Subscribe location={location} />}
          <SweetwaterRewards />
          <Footer />
        </>
        : null}
    </div>
  )
}

export default Layout
